import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { Reveal } from './Reveal';
import { CheckIcon } from './icons/Icons';
const faqs = [{
  q: '¿Funciona si tengo H. Pylori?',
  a: 'Sí. El protocolo fortalece el ambiente gástrico, lo cual es fundamental para cualquier tratamiento contra la bacteria.'
}, {
  q: '¿Tengo que dejar de comer de todo?',
  a: 'No. El objetivo es sanar para que vuelvas a comer normal. Solo hacemos ajustes estratégicos por 21 días.'
}, {
  q: '¿Es una suscripción mensual?',
  a: 'No. Es un pago único de $10.99 y el acceso es de por vida.'
}];
function PlusToggle({
  open
}: {
  open: boolean;
}) {
  return <span className="relative flex h-6 w-6 shrink-0 items-center justify-center" data-id="element-71">
      <span className="absolute h-0.5 w-3.5 rounded bg-[#3f6b3a]" data-id="element-72" />
      <motion.span animate={{
      rotate: open ? 0 : 90
    }} transition={{
      duration: 0.25
    }} className="absolute h-0.5 w-3.5 rounded bg-[#3f6b3a]" data-id="element-73" />
    </span>;
}
export function FaqSection() {
  const [open, setOpen] = useState<number | null>(0);
  return <section className="w-full bg-[#f7f4ec] py-16 sm:py-20" data-id="element-74">
      <div className="mx-auto max-w-2xl px-5" data-id="element-75">
        <Reveal data-id="element-76">
          <p className="text-center text-xs font-semibold uppercase tracking-[0.2em] text-[#3f6b3a]" data-id="element-77">
            Preguntas Frecuentes
          </p>
          <h2 className="mt-2 text-center font-display text-3xl font-extrabold text-[#1f2a22] sm:text-4xl" data-id="element-78">
            Aún tienes dudas
          </h2>
        </Reveal>

        <div className="mt-9 space-y-3" data-id="element-79">
          {faqs.map((faq, i) => {
          const isOpen = open === i;
          return <Reveal key={faq.q} delay={i * 0.06} data-id="element-80">
                <div className="overflow-hidden rounded-xl border border-[#3f6b3a]/12 bg-white shadow-sm" data-id="element-81">
                  <button onClick={() => setOpen(isOpen ? null : i)} aria-expanded={isOpen} className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left" data-id="element-82">
                    <span className="font-display text-base font-bold text-[#1f2a22] sm:text-lg" data-id="element-83">
                      {faq.q}
                    </span>
                    <PlusToggle open={isOpen} data-id="element-84" />
                  </button>
                  <AnimatePresence initial={false} data-id="element-85">
                    {isOpen && <motion.div initial={{
                  height: 0,
                  opacity: 0
                }} animate={{
                  height: 'auto',
                  opacity: 1
                }} exit={{
                  height: 0,
                  opacity: 0
                }} transition={{
                  duration: 0.3,
                  ease: 'easeInOut'
                }} data-id="element-86">
                        <div className="flex items-start gap-2.5 px-5 pb-5 text-[#3d4a40]" data-id="element-87">
                          <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-[#3f6b3a] text-white" data-id="element-88">
                            <CheckIcon className="h-3 w-3" strokeWidth={3.2} data-id="element-89" />
                          </span>
                          <p className="text-base leading-relaxed" data-id="element-90">{faq.a}</p>
                        </div>
                      </motion.div>}
                  </AnimatePresence>
                </div>
              </Reveal>;
        })}
        </div>
      </div>
    </section>;
}